import { Switch } from "@/components/ui/switch";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { PenLine, Trash2 } from "lucide-react";
import CreateVariantDialog from "@/components/dialog/menu-manage/common-dialog/create-variant-dialog";
import UpdateVariantDialog from "@/components/dialog/menu-manage/common-dialog/update-variant-dialog";
import CreateIngredientDialog from "@/components/dialog/menu-manage/common-dialog/create-ingredients";
import CreateAddonsDialog from "@/components/dialog/menu-manage/common-dialog/create-addons";
import CreateAllergenDialog from "@/components/dialog/menu-manage/common-dialog/create-allergen";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "@/components/ui/table";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { calculatePriceWithVAT } from "@/lib/utils";
import { ButtonType } from "@/components/lib/Button";
import { deleteVariantById } from "@/redux/slice/essential-menu-slice/variants-slice";
import { useDispatch } from "react-redux";
import { setItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import { DeleteConfirmDialog } from "@/components/dialog/common-dialog";
import { Loader2 } from "lucide-react";
import {
  fetchSingleDessert,
  updateExistingDessert,
} from "@/redux/slice/menu-manage-slice/dessert-slice";
import { toast } from "react-hot-toast";

function Step2({ form, dessert_id, item_id }) {
  const dispatch = useDispatch();
  const [deleteDialog, setDeleteDialog] = useState(false);
  const add_on_ids = form.watch("add_on_ids");
  const ingredient_ids = form.watch("ingredient_ids");
  const [loading, setLoading] = useState(false);
  const allergen_ids = form.watch("allergen_ids");
  const [showIngredient, setShowIngredient] = useState(false);
  const [showAddons, setShowAddons] = useState(false);
  const [showAllergen, setShowAllergens] = useState(false);
  const [createVariantDialog, setCreateVariantDialog] = useState(false);
  const [updateVariantDialog, setUpdateVariantDialog] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [createNewAllergen, setCreateNewAllergen] = useState(false);
  const [createNewIndredients, setCreateNewIndredients] = useState(false);
  const [createNewAddOn, setCreateNewAddOn] = useState(false);
  const { itemVariants } = useSelector((state) => state.essentialMenu.variants);
  const { addOns } = useSelector((state) => state.essentialMenu.addOns);
  const { ingredients } = useSelector(
    (state) => state.essentialMenu.ingredients
  );
  const { allergens } = useSelector((state) => state.essentialMenu.allergens);

  useEffect(() => {
    const fetchSingleItem = async () => {
      try {
        const res = await dispatch(fetchSingleDessert(item_id));
        if (fetchSingleDessert.fulfilled.match(res)) {
          const item = res?.payload?.variants;
          dispatch(setItemVariants(item));
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchSingleItem();
  }, []);

  const handleVariantCreated = async (newVariantId) => {
    if (!newVariantId) return;
    setLoading(true);
    const allVariantIds = [...itemVariants.map((v) => v.id), newVariantId];
    form.setValue("variant_ids", allVariantIds);
    try {
      const res = await dispatch(
        updateExistingDessert({
          id: item_id,
          data: {
            status: `${
              form.watch("type") === "update" ? form.watch("status") : "draft"
            }`,
            variant_ids: allVariantIds,
          },
        })
      );
      if (updateExistingDessert.fulfilled.match(res)) {
        // toast.success("Drink updated with new variant successfully.");
      } else {
        // toast.error(res?.payload || "Failed to update the drink.");
      }
    } catch (error) {
      toast.error("Failed to update the item with new variant.");
    }
    setLoading(false);
  };

  const closeVariant = () => {
    setCreateVariantDialog(false);
  };
  const closeUpdateVariant = () => {
    setUpdateVariantDialog(false);
    setSelectedVariant(null);
  };
  const closeNewAllergen = () => {
    setCreateNewAllergen(false);
  };
  const closeNewIndredients = () => {
    setCreateNewIndredients(false);
  };
  const closeCreateNewAdd = () => {
    setCreateNewAddOn(false);
  };

  useEffect(() => {
    setShowAllergens(Array.isArray(allergen_ids) && allergen_ids.length > 0);
    setShowAddons(Array.isArray(add_on_ids) && add_on_ids.length > 0);
    setShowIngredient(
      Array.isArray(ingredient_ids) && ingredient_ids.length > 0
    );
  }, [allergen_ids, add_on_ids, ingredient_ids]);

  const deleteHandler = async (id) => {
    try {
      if (!id) {
        toast.error("Variant ID is required to delete.");
        return;
      }
      const res = await dispatch(deleteVariantById(id));
      if (deleteVariantById.fulfilled.match(res)) {
        toast.success("Variant deleted successfully.");
        handleVariantCreated(id);
        setSelectedVariant(null);
        setDeleteDialog(false);
      } else if (deleteVariantById.rejected.match(res)) {
        toast.error(res?.payload || "Failed to delete the variant.");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    }
  };

  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {form.watch("type") == "update"
            ? "Update Dessert"
            : "Add New Dessert         "}
        </CardTitle>
        <CardDescription className="text-cyellow">
          Item name: {form.watch("name") || "No name"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-5">
          <div className="flex justify-between items-center gap-5">
            <CardTitle>Varinat & Price</CardTitle>
            <ButtonType onClick={() => setCreateVariantDialog(true)}>
              Create New Variants & Price
            </ButtonType>
            <CreateVariantDialog
              title={"Create New Variant & Price"}
              menu_id={dessert_id}
              onClose={closeVariant}
              isOpen={createVariantDialog}
              onSuccess={(newVariantId) => handleVariantCreated(newVariantId)}
              item_id={item_id}
              item_type="dessert"
            />
          </div>

          <div className="relative">
            <Table>
              <TableHeader>
                <TableRow>
                  {/* <TableHead>Select</TableHead> */}
                  <TableHead>Variant</TableHead>
                  <TableHead>Calorie Amount</TableHead>
                  <TableHead>In-Price(exc VAT)</TableHead>
                  <TableHead>In-Price(inc VAT)</TableHead>
                  <TableHead>Out-Price(exc VAT)</TableHead>
                  <TableHead>Out-Price(inc VAT)</TableHead>
                  <TableHead className="text-right">Action</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody>
                {itemVariants && itemVariants.length > 0 ? (
                  itemVariants.map((item, index) => {
                    // const isChecked = form
                    //   .watch("variant_ids")
                    //   ?.includes(item.id);

                    return (
                      <TableRow key={index}>
                        {/* <TableCell>
                        <Checkbox
                          checked={isChecked}
                          onCheckedChange={(checked) => {
                            const currentIds =
                              form.getValues("variant_ids") || [];
                            if (checked) {
                              form.setValue("variant_ids", [
                                ...currentIds,
                                item.id,
                              ]);
                            } else {
                              form.setValue(
                                "variant_ids",
                                currentIds.filter((id) => id !== item.id)
                              );
                            }
                          }}
                        />
                      </TableCell> */}

                        <TableCell>{item?.name || "No name"}</TableCell>
                        <TableCell>
                          {item?.calorie_amount || "0"} kcal
                        </TableCell>
                        <TableCell>${item?.in_price || "0"}</TableCell>
                        <TableCell>
                          ${calculatePriceWithVAT(item?.in_price, 0) || "0"}
                        </TableCell>
                        <TableCell>${item?.out_price || "0"}</TableCell>
                        <TableCell>
                          ${calculatePriceWithVAT(item?.out_price, 0) || "0"}
                        </TableCell>
                        <TableCell>
                          <div className="flex gap-2 justify-end items-center">
                            <span>
                              <PenLine
                                onClick={() => {
                                  setUpdateVariantDialog(true);
                                  setSelectedVariant(item);
                                }}
                                className="text-cgreen cursor-pointer"
                                size={18}
                              />
                            </span>
                            <Trash2
                              onClick={() => {
                                setDeleteDialog(true);
                                setSelectedVariant(item);
                              }}
                              className="text-cred cursor-pointer"
                              size={18}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} className="text-center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {loading && (
              <div className="absolute inset-0 bg-black/40 flex justify-center items-center z-10">
                <Loader2 className="animate-spin" size={18} />
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-8 mt-5">
          <div className="flex justify-between items-end gap-5">
            <div className="w-full">
              <div className="flex gap-2 items-center">
                <Switch
                  checked={showIngredient}
                  onCheckedChange={(val) => {
                    setShowIngredient(val);
                    if (!val) {
                      form.setValue("ingredient_ids", []);
                    }
                  }}
                />
                <Label>Ingredients</Label>
              </div>
              <div className="flex gap-5 justify-between items-end">
                {showIngredient && (
                  <div className="w-full mt-3">
                    <FormInputField
                      name="ingredient_ids"
                      type="multiselect"
                      label="Ingredients"
                      placeholder="Select Ingredients"
                      selectOption={
                        ingredients && ingredients?.length > 0
                          ? ingredients
                            .filter((item) => item?.status === "active")
                            .map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))
                          : [
                              {
                                label: "Not available",
                                value: "",
                                disabled: true,
                              },
                            ]
                      }
                      form={form}
                      style="bg-cblack7"
                    />
                  </div>
                )}
              </div>
            </div>
            {showIngredient && (
              <ButtonType onClick={() => setCreateNewIndredients(true)}>
                Create New Ingredients
              </ButtonType>
            )}
            <CreateIngredientDialog
              title={"Create New Ingredients"}
              menu_id={dessert_id}
              onClose={closeNewIndredients}
              isOpen={createNewIndredients}
            />
          </div>

          <div className="flex justify-between items-end gap-5">
            <div className="flex flex-col w-full">
              <div className="flex gap-2 items-center w-full">
                <Switch
                  checked={showAddons}
                  onCheckedChange={(val) => {
                    setShowAddons(val);
                    if (!val) {
                      form.setValue("add_on_ids", []);
                    }
                  }}
                />
                <Label>Add-ons</Label>
              </div>
              {showAddons && (
                <div className="w-full mt-3">
                  <FormInputField
                    name="add_on_ids"
                    type="multiselect"
                    label="Add Ons"
                    style="w-full bg-cblack7"
                    placeholder="Select Add Ons"
                    selectOption={
                      addOns && addOns?.length > 0
                        ? addOns
                          .filter((item) => item?.status === "active")
                          .map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))
                        : [
                            {
                              label: "Not available",
                              value: "",
                              disabled: true,
                            },
                          ]
                    }
                    form={form}
                  />
                </div>
              )}
            </div>
            {showAddons && (
              <ButtonType onClick={() => setCreateNewAddOn(true)}>
                Create New Add-ons
              </ButtonType>
            )}
            <CreateAddonsDialog
              title={"Create New Add-ons"}
              menu_id={dessert_id}
              onClose={closeCreateNewAdd}
              isOpen={createNewAddOn}
            />
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <div className="flex gap-2 items-center">
                  <Switch
                    checked={showAllergen}
                    onCheckedChange={(val) => {
                      setShowAllergens(val);
                      if (!val) {
                        form.setValue("allergen_ids", []);
                      }
                    }}
                  />
                  <Label>
                    Allergen{" "}
                    <span className="text-sm font-light">(shows on items)</span>
                  </Label>
                </div>
                {showAllergen && (
                  <div className="space-y-2 flex mt-2 w-full">
                    <FormInputField
                      name="allergen_ids"
                      style="bg-cblack7 flex-1"
                      placeholder={"Select Allergens"}
                      form={form}
                      type="multiselect"
                      label={"Allergens"}
                      selectOption={
                        allergens && allergens?.length > 0
                          ? allergens
                            .filter((item) => item?.status === "active")
                            .map((item) => ({
                              label:
                                item.name +
                                (item?.short_name ? ` (${item.short_name})` : ""),
                              value: item.id,
                            }))
                          : [
                              {
                                label: "Not available",
                                value: "",
                                disabled: true,
                              },
                            ]
                      }
                    />
                  </div>
                )}
              </div>
              {showAllergen && (
                <ButtonType onClick={() => setCreateNewAllergen(true)}>
                  Create New Allergen
                </ButtonType>
              )}
              <CreateAllergenDialog
                menu_id={dessert_id}
                title={"Create New Allergen"}
                onClose={closeNewAllergen}
                isOpen={createNewAllergen}
              />
            </div>
          </div>
        </div>
      </CardContent>

      <UpdateVariantDialog
        onClose={closeUpdateVariant}
        isOpen={updateVariantDialog}
        title="Update New Variant & Price"
        variantData={selectedVariant}
      />
      <DeleteConfirmDialog
        isOpen={deleteDialog}
        onClose={() => setDeleteDialog(false)}
        onConfirm={() => {
          deleteHandler(selectedVariant.id);
        }}
        personName={""}
      />
    </Card>
  );
}

export default Step2;
